<div class="container dialog-container">

  <h1 mat-dialog-title>Manage Fisheries</h1>

  <div mat-dialog-content>
    <mat-radio-group [(ngModel)]="selectedOption">
      <mat-radio-button class="row" value="trawl">
        Groundfish Trawl
      </mat-radio-button>
      <mat-radio-button class="row" value="groundfishNonTrawl">
        Groundfish Non-Trawl
      </mat-radio-button>
      <mat-radio-button class="row" value="hms">
        HMS
      </mat-radio-button>
      <!--mat-radio-button class="row" value="both">
        Groundfish Non-Trawl + HMS
      </mat-radio-button-->

    </mat-radio-group>

    <!-- Error message -->
    <mat-error *ngIf="selectError" align="left" style="font-style: italic; color: red;">
      Please select a fishery
    </mat-error>
  </div>

  <!-- Buttons -->
  <div class="row buttons">
    <button mat-fab
            class="text-blue-button"
            type="button"
            (click)="onBackClick()">
      Cancel
    </button>

    <button mat-fab
            class="text-button"
            type="button"
            aria-label="Add Fishery"
            (click)="onConfirmClick()">
      OK
    </button>
  </div>

</div>
